 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"9eebc964d28c30f894b8d48e8a9143aefc2c61fc","2":"26e822513d4bb3eca28ba2ba3f1009b0d295dba5","3":"6f416d86784ad1443bb4986bea1ee577a45ad8e0","4":"9be315d4593510a9d44232284901feead37402cd","5":"d34828427decfd95c5467044f77b3c75c9488cc6","6":"e547faeaf0087435ae734fd2b8d72ea9f338a443","7":"20b06f1bfedbda7bdfeaa6d851fb2a0f7f2bf0d9","8":"ed2beae0fa5ec1f65ae6196e2c5d792b6a0cf364","9":"9c76abb668ce084ba6235afa512f23fcdf0ac92f","10":"bbcbd6fbe34eeaaf6cf98155aadcd7f41dda84d4","11":"component---src-pages-nutritiondirect-form-js","12":"component---src-pages-vitaminb-12-form-js","14":"6278397b","16":"component---src-pages-404-js","17":"component---src-pages-index-js","18":"component---src-pages-nutritiondirect-bariactiv-js","19":"component---src-pages-nutritiondirect-faqs-js","20":"component---src-pages-nutritiondirect-hcp-bariactiv-js","21":"component---src-pages-nutritiondirect-hcp-index-js","22":"component---src-pages-nutritiondirect-hcp-nasal-spray-js","23":"component---src-pages-nutritiondirect-hcp-patient-resources-js","24":"component---src-pages-nutritiondirect-hcp-practice-resources-js","25":"component---src-pages-nutritiondirect-hcp-program-details-js","26":"component---src-pages-nutritiondirect-hcp-rdn-guidelines-index-js","27":"component---src-pages-nutritiondirect-index-js","28":"component---src-pages-nutritiondirect-nasal-spray-js","29":"component---src-pages-nutritiondirect-procare-signup-js","30":"component---src-pages-nutritiondirect-recipes-js","31":"component---src-pages-nutritiondirect-resources-js","32":"component---src-pages-nutritiondirect-signup-js","33":"component---src-pages-nutritiondirect-videos-js","34":"component---src-pages-nutritiondirect-why-nutrition-direct-js","35":"component---src-pages-todaysdietitian-js","36":"component---src-pages-vitaminb-12-about-js","37":"component---src-pages-vitaminb-12-b-12-deficiency-js","38":"component---src-pages-vitaminb-12-faqs-js","39":"component---src-pages-vitaminb-12-hcp-about-js","40":"component---src-pages-vitaminb-12-hcp-b-12-deficiency-js","41":"component---src-pages-vitaminb-12-hcp-b-12-options-js","42":"component---src-pages-vitaminb-12-hcp-clinical-data-js","43":"component---src-pages-vitaminb-12-hcp-faqs-js","44":"component---src-pages-vitaminb-12-hcp-how-js","45":"component---src-pages-vitaminb-12-hcp-index-js","46":"component---src-pages-vitaminb-12-hcp-patient-resources-js","47":"component---src-pages-vitaminb-12-hcp-practice-resources-js","48":"component---src-pages-vitaminb-12-hcp-request-a-sales-rep-js","49":"component---src-pages-vitaminb-12-hcp-why-js","50":"component---src-pages-vitaminb-12-how-js","51":"component---src-pages-vitaminb-12-index-js","52":"component---src-pages-vitaminb-12-resources-js","53":"component---src-pages-vitaminb-12-signup-js","54":"component---src-pages-vitaminb-12-why-js","55":"component---src-templates-recipe-js"}[chunkId]||chunkId) + "-" + {"0":"89fd2ae28bdf06750a71","1":"b933daca1281f1eb7979","2":"ef4460b6f39fc0b31d50","3":"a7e434c8b8a0b623309e","4":"f35fca7f13253be301d6","5":"2cb12e2d552d157aa941","6":"f2c4d3e4e7bf23c79c60","7":"f5db5d2c3f46946dabda","8":"d83820fff079b94d9ff9","9":"b0a3179858c8b949f3ed","10":"8272c6f2b8361f199c95","11":"4caa9625b7cef0a4cee0","12":"dc8a7f5e6d1a187508a3","14":"a88840118b2c3eb1f47d","16":"5a4cdd12976fcf77a9c8","17":"1e49f477c18b19423994","18":"f6bcaf64e67a38d3287c","19":"14c4f521b97c1115d805","20":"d8b6a395db70a08e69ac","21":"51a66479c55c44619d23","22":"4f0fbab0df3f5d3634f9","23":"aea0804741e627683062","24":"3782f5742fe5783df7b9","25":"11eb943be960815ff8db","26":"31b52c955b2038080c3b","27":"3396d7b12542f03fe1bf","28":"ef8a8e533865c3076197","29":"5575419daab4b236b506","30":"45c53e8dc834a7293b12","31":"24aee30b9c65abf7a8f7","32":"290bf89618e7e2eef809","33":"4c1119e67548df862b8b","34":"70b7e1d4d8adc8bfa01b","35":"9bf630bbb306e69c56df","36":"ac417f174407c58308df","37":"60aff5f5ffc55cea4470","38":"8d05f5ac82696022f4a7","39":"71183bbf77cb2097b074","40":"d3fa175b5fea50da1a0f","41":"b08cf3e93e885d73c114","42":"bccd36d494a79cdd6a7c","43":"1343c6f19a5eccd58f04","44":"740464685d52f1b78d36","45":"4a5aa893f95d9daa63a3","46":"686c5f45314db4f1004f","47":"025ab48046790151aff1","48":"29ee213bf07806d10fe0","49":"c9e6e94c3576729b4e34","50":"7d765634155dbed4dd62","51":"645a43799b8221ece0b4","52":"ce8ef994bb178c615a57","53":"432c89c430ca0aeff6fc","54":"f1128f7f857f7e5652ff","55":"6330c38732102e5fe3c8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"9eebc964d28c30f894b8d48e8a9143aefc2c61fc","2":"26e822513d4bb3eca28ba2ba3f1009b0d295dba5","3":"6f416d86784ad1443bb4986bea1ee577a45ad8e0","4":"9be315d4593510a9d44232284901feead37402cd","5":"d34828427decfd95c5467044f77b3c75c9488cc6","6":"e547faeaf0087435ae734fd2b8d72ea9f338a443","7":"20b06f1bfedbda7bdfeaa6d851fb2a0f7f2bf0d9","8":"ed2beae0fa5ec1f65ae6196e2c5d792b6a0cf364","9":"9c76abb668ce084ba6235afa512f23fcdf0ac92f","10":"bbcbd6fbe34eeaaf6cf98155aadcd7f41dda84d4","11":"component---src-pages-nutritiondirect-form-js","12":"component---src-pages-vitaminb-12-form-js","14":"6278397b","16":"component---src-pages-404-js","17":"component---src-pages-index-js","18":"component---src-pages-nutritiondirect-bariactiv-js","19":"component---src-pages-nutritiondirect-faqs-js","20":"component---src-pages-nutritiondirect-hcp-bariactiv-js","21":"component---src-pages-nutritiondirect-hcp-index-js","22":"component---src-pages-nutritiondirect-hcp-nasal-spray-js","23":"component---src-pages-nutritiondirect-hcp-patient-resources-js","24":"component---src-pages-nutritiondirect-hcp-practice-resources-js","25":"component---src-pages-nutritiondirect-hcp-program-details-js","26":"component---src-pages-nutritiondirect-hcp-rdn-guidelines-index-js","27":"component---src-pages-nutritiondirect-index-js","28":"component---src-pages-nutritiondirect-nasal-spray-js","29":"component---src-pages-nutritiondirect-procare-signup-js","30":"component---src-pages-nutritiondirect-recipes-js","31":"component---src-pages-nutritiondirect-resources-js","32":"component---src-pages-nutritiondirect-signup-js","33":"component---src-pages-nutritiondirect-videos-js","34":"component---src-pages-nutritiondirect-why-nutrition-direct-js","35":"component---src-pages-todaysdietitian-js","36":"component---src-pages-vitaminb-12-about-js","37":"component---src-pages-vitaminb-12-b-12-deficiency-js","38":"component---src-pages-vitaminb-12-faqs-js","39":"component---src-pages-vitaminb-12-hcp-about-js","40":"component---src-pages-vitaminb-12-hcp-b-12-deficiency-js","41":"component---src-pages-vitaminb-12-hcp-b-12-options-js","42":"component---src-pages-vitaminb-12-hcp-clinical-data-js","43":"component---src-pages-vitaminb-12-hcp-faqs-js","44":"component---src-pages-vitaminb-12-hcp-how-js","45":"component---src-pages-vitaminb-12-hcp-index-js","46":"component---src-pages-vitaminb-12-hcp-patient-resources-js","47":"component---src-pages-vitaminb-12-hcp-practice-resources-js","48":"component---src-pages-vitaminb-12-hcp-request-a-sales-rep-js","49":"component---src-pages-vitaminb-12-hcp-why-js","50":"component---src-pages-vitaminb-12-how-js","51":"component---src-pages-vitaminb-12-index-js","52":"component---src-pages-vitaminb-12-resources-js","53":"component---src-pages-vitaminb-12-signup-js","54":"component---src-pages-vitaminb-12-why-js","55":"component---src-templates-recipe-js"}[chunkId]||chunkId) + "." + {"0":"116874cbfb8a99d1a7bf","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
